var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownDashed(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 26,
    viewBox: "0 0 9 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.14645 25.1231C4.34171 25.3183 4.65829 25.3183 4.85355 25.1231L8.03553 21.9411C8.2308 21.7458 8.2308 21.4293 8.03553 21.234C7.84027 21.0387 7.52369 21.0387 7.32843 21.234L4.5 24.0624L1.67157 21.234C1.47631 21.0387 1.15973 21.0387 0.964466 21.234C0.769204 21.4293 0.769204 21.7458 0.964466 21.9411L4.14645 25.1231ZM5 24.7695L5 23.7695L4 23.7695L4 24.7695L5 24.7695ZM5 21.7695L5 19.7695L4 19.7695L4 21.7695L5 21.7695ZM5 17.7695L5 15.7695L4 15.7695L4 17.7695L5 17.7695ZM5 13.7695L5 11.7695L4 11.7695L4 13.7695L5 13.7695ZM5 9.76953L5 7.76953L4 7.76953L4 9.76953L5 9.76953ZM5 5.76953L5 3.76953L4 3.76953L4 5.76953L5 5.76953ZM5 1.76953L5 0.769531L4 0.769531L4 1.76953L5 1.76953Z",
    fill: "#667685"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownDashed);
export default __webpack_public_path__ + "static/media/arrow-down-dashed.003af791398bc9854da14e80a80b687f.svg";
export { ForwardRef as ReactComponent };